Monitoring.Views ||= {}

class Monitoring.Views.ProfileActionsEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/profile_actions_edit"]

  events:
    'change #selected-user-profile-tag': 'onChangeSelectedUserProfileTag'


  initialize: (@options = {}) ->
    @addTagToUserProfileAction = @options.addTagToUserProfileAction
    @availableUserProfileTags = @options.availableUserProfileTags

  render: =>
    @$el.html(@template(@))
    @

  getActions: ->
    [@addTagToUserProfileAction]

  onChangeSelectedUserProfileTag: (evt) =>
    selectedUserProfileTagId = $(evt.currentTarget).find('option:selected').val();

    if selectedUserProfileTagId == ''
      @addTagToUserProfileAction = undefined
    else
      @addTagToUserProfileAction = {
        type: 'add_tag_to_user_profile',
        user_profile_tag:
          id: selectedUserProfileTagId
      }
    @trigger('changed-mandatory-field')

  allMandatoryFieldsAreFilled: =>
    @addTagToUserProfileAction!= undefined && !_.isEmpty(@addTagToUserProfileAction.user_profile_tag)